import axios from "axios";
import { getPlatformToken } from "@/lib/musicApi";

const API_PREFIX = `${process.env.REACT_APP_BACKEND_URL}/api/`;

// Signed-in visitors carry their platform token on bare axios calls to our API.
// No token, a foreign URL, or an explicit Authorization header -> config untouched.
axios.interceptors.request.use((cfg) => {
  const t = getPlatformToken();
  if (!t || typeof cfg.url !== "string" || !cfg.url.startsWith(API_PREFIX)) return cfg;
  if (cfg.headers.has("Authorization")) return cfg;
  cfg.headers.set("Authorization", `Bearer ${t}`);
  return cfg;
});
